var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-80px", attrs: { id: "tlacDokumentov" } },
    [
      _c(
        "v-container",
        { staticClass: "fill-height" },
        [
          _c("h1", { staticClass: "my-7" }, [
            _vm._v(" Tlač dokumentov - " + _vm._s(this.cisloObchPripadu)),
            this.cisloPredmetu > 0
              ? _c("span", [_vm._v(" - " + _vm._s(this.nazovPredmetu))])
              : _vm._e()
          ]),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { attrs: { elevation: "10" } },
                    [
                      !!_vm.messageOk
                        ? _c("v-alert", { attrs: { type: "success" } }, [
                            _vm._v(" " + _vm._s(_vm.messageOk))
                          ])
                        : _vm._e(),
                      !!_vm.messageErr
                        ? _c("v-alert", { attrs: { type: "error" } }, [
                            _vm._v(" " + _vm._s(_vm.messageErr))
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        {
                          staticClass: "mx-10px",
                          attrs: { align: "start", justify: "start" }
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                {
                                  class: [
                                    _vm.sticky ? "tlac_fixed_buttons" : ""
                                  ],
                                  attrs: {
                                    align: "start",
                                    justify: "space-between"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-10px my-10px",
                                      attrs: {
                                        color: "primary",
                                        depressed: "",
                                        loading:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS,
                                        disabled:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS
                                      },
                                      on: { click: _vm.showSelected }
                                    },
                                    [_vm._v("Zobraziť dokumenty")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-10px my-10px",
                                      attrs: {
                                        color: "primary",
                                        depressed: "",
                                        loading:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS,
                                        disabled:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS
                                      },
                                      on: { click: _vm.downloadSelected }
                                    },
                                    [_vm._v("Stiahnuť dokumenty")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-10px my-10px",
                                      attrs: {
                                        color: "primary",
                                        depressed: "",
                                        loading:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS,
                                        disabled:
                                          _vm.downloadingTLAC ||
                                          _vm.downloadingDMS
                                      },
                                      on: { click: _vm.sendSelected }
                                    },
                                    [_vm._v("Odoslať dokumenty emailom")]
                                  ),
                                  _c("check-box", {
                                    staticClass: "ml-10px my-10px",
                                    attrs: {
                                      label: "Odoslať automaticky",
                                      disabled: _vm.poslatAutomatickyDisabled
                                    },
                                    model: {
                                      value: _vm.poslatAutomaticky,
                                      callback: function($$v) {
                                        _vm.poslatAutomaticky = $$v
                                      },
                                      expression: "poslatAutomaticky"
                                    }
                                  }),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn-secondary mr-10px my-10px",
                                      attrs: { depressed: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.go(-1)
                                        }
                                      }
                                    },
                                    [_vm._v(" Späť ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pl-25px", attrs: { elevation: "10" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex py-7",
                          on: {
                            click: function($event) {
                              _vm.toggleNajomca = !_vm.toggleNajomca
                            }
                          }
                        },
                        [
                          _c("h2", [_vm._v("Nájomca")]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-auto mr-25px",
                              attrs: { icon: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                { class: { "rotate-180": _vm.toggleNajomca } },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expand-transition",
                        [
                          _c(
                            "v-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.toggleNajomca,
                                  expression: "toggleNajomca"
                                }
                              ],
                              attrs: { align: "start", justify: "start" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mt-n5", attrs: { cols: "12" } },
                                [
                                  _c("v-data-table", {
                                    ref: "vDataTableTLACNajomca",
                                    staticClass: "pr-20px",
                                    attrs: {
                                      headers: _vm.headersTlacNajomca,
                                      items: _vm.dokumentyTlacNajomca,
                                      "hide-default-footer": "",
                                      page: _vm.pageTLAC,
                                      "items-per-page": _vm.perPageItemCount,
                                      "item-key": "pkid",
                                      loading:
                                        _vm.loadingTLAC || _vm.downloadingTLAC,
                                      loadingText: "Načítavam dáta ...",
                                      "show-select": ""
                                    },
                                    on: {
                                      "update:page": function($event) {
                                        _vm.pageTLAC = $event
                                      },
                                      "page-count": function($event) {
                                        _vm.pageCountTLAC = $event
                                      },
                                      "dblclick:row": _vm.rowDoubleClick
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.modifikovane",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.modifikovane
                                                      ? item.modifikovane.formatDateTime()
                                                      : ""
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedTLAC,
                                      callback: function($$v) {
                                        _vm.selectedTLAC = $$v
                                      },
                                      expression: "selectedTLAC"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.dokumentyTlacPredmety, function(tlaciva, t) {
            return _c(
              "v-row",
              { key: t, attrs: { align: "center", justify: "center" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "v-card",
                      { staticClass: "pl-25px", attrs: { elevation: "10" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex py-7",
                            on: {
                              click: function($event) {
                                return _vm.expandPredmety(tlaciva.cisloPredmetu)
                              }
                            }
                          },
                          [
                            _c("h2", [_vm._v(_vm._s(tlaciva.nazovPredmetu))]),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-secondary ml-auto mr-25px",
                                attrs: { icon: "" }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { class: { "rotate-180": tlaciva.expanded } },
                                  [_vm._v("mdi-chevron-down")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-expand-transition",
                          [
                            _c(
                              "v-row",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: tlaciva.expanded,
                                    expression: "tlaciva.expanded"
                                  }
                                ],
                                attrs: { align: "start", justify: "start" }
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "mt-n5",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c("v-data-table", {
                                      ref: "vDataTableTLACPredmety",
                                      refInFor: true,
                                      staticClass: "pr-20px",
                                      attrs: {
                                        headers: _vm.headersTlacPredmety,
                                        items: tlaciva.tlaciva,
                                        "hide-default-footer": "",
                                        page: _vm.pageTLAC,
                                        "items-per-page": _vm.perPageItemCount,
                                        "item-key": "pkid",
                                        loading:
                                          _vm.loadingTLAC ||
                                          _vm.downloadingTLAC,
                                        loadingText: "Načítavam dáta ...",
                                        "show-select": ""
                                      },
                                      on: {
                                        "update:page": function($event) {
                                          _vm.pageTLAC = $event
                                        },
                                        "page-count": function($event) {
                                          _vm.pageCountTLAC = $event
                                        },
                                        "dblclick:row": _vm.rowDoubleClick
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item.modifikovane",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.modifikovane
                                                        ? item.modifikovane.formatDateTime()
                                                        : ""
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.selectedTLAC,
                                        callback: function($$v) {
                                          _vm.selectedTLAC = $$v
                                        },
                                        expression: "selectedTLAC"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pl-25px", attrs: { elevation: "10" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex py-7",
                          on: {
                            click: function($event) {
                              _vm.toggleDMS = !_vm.toggleDMS
                            }
                          }
                        },
                        [
                          _c("h2", [_vm._v("Dokumenty na podpis")]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-auto mr-25px",
                              attrs: { icon: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                { class: { "rotate-180": _vm.toggleDMS } },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expand-transition",
                        [
                          _c(
                            "v-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.toggleDMS,
                                  expression: "toggleDMS"
                                }
                              ],
                              attrs: { align: "start", justify: "start" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mt-n5", attrs: { cols: "12" } },
                                [
                                  _c("v-data-table", {
                                    ref: "vDataTableDMS",
                                    staticClass: "pr-20px",
                                    attrs: {
                                      headers: _vm.headersDMS,
                                      items: _vm.dokumentyDMS,
                                      "hide-default-footer": "",
                                      page: _vm.pageDMS,
                                      "items-per-page": _vm.perPageItemCount,
                                      "item-key": "pkid",
                                      loading:
                                        _vm.loadingDMS || _vm.downloadingDMS,
                                      loadingText: "Načítavam dáta ...",
                                      "show-select": ""
                                    },
                                    on: {
                                      "update:page": function($event) {
                                        _vm.pageDMS = $event
                                      },
                                      "page-count": function($event) {
                                        _vm.pageCountDMS = $event
                                      },
                                      "dblclick:row": _vm.rowDoubleClickDMS
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.modifikovane",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.modifikovane
                                                      ? item.modifikovane.formatDateTime()
                                                      : ""
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedDMS,
                                      callback: function($$v) {
                                        _vm.selectedDMS = $$v
                                      },
                                      expression: "selectedDMS"
                                    }
                                  }),
                                  _c("v-pagination", {
                                    staticClass: "table-nav",
                                    attrs: { length: _vm.pageCountDMS },
                                    model: {
                                      value: _vm.pageDMS,
                                      callback: function($$v) {
                                        _vm.pageDMS = $$v
                                      },
                                      expression: "pageDMS"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-overlay",
            {
              attrs: {
                color: "#000",
                opacity: "0.40",
                value: _vm.loadingRefi.loading,
                "z-index": 5
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "text-center mt-n100px",
                  staticStyle: { padding: "25px 30px 30px 30px" },
                  attrs: { width: "500" }
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "mb-20px",
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: 25,
                      width: 2
                    }
                  }),
                  _c("text-group", {
                    attrs: {
                      invert: "",
                      large: "",
                      utext: _vm.loadingRefi.text,
                      btext: "Upozornenie",
                      gap: 20
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }